// FinanceTab.tsx — Mandate Finance: the borrow / lend side of the business, operator only.
// Deals: every deal room and its stage gates. Network: open term sheets and capital posts.
// Counterparties: the registry — firms, portal seats, the verified mark, the ROATA monitoring link, KYB notes.
// Governance stays the advisory / RFP side. The two share the entity registry (a market maker on a
// Governance mandate can be a borrower here) and nothing else in the UI.
import { useState } from "react";
import { CounterpartiesView, DealsView, NetworkView } from "./MarketMakersView.tsx";

const TEXT = "#cfe0ff";
const MUTED = "#8a93a6";
const SUBS = [["deals", "Deals"], ["network", "Network"], ["counterparties", "Counterparties"]] as const;
type Sub = (typeof SUBS)[number][0];

export function FinanceTab({ identity }: { identity: { role: string } }) {
  const [sub, setSub] = useState<Sub>("deals");
  if (identity.role !== "operator") return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="subtabs" style={{ display: "flex", gap: 8 }}>
        {SUBS.map(([id, label]) => (
          <button key={id} onClick={() => setSub(id)}
            style={{ fontSize: 13, padding: "6px 14px", borderRadius: 6, cursor: "pointer",
              border: `1px solid ${sub === id ? "rgba(102,153,255,0.35)" : "transparent"}`,
              background: sub === id ? "rgba(102,153,255,0.16)" : "transparent",
              color: sub === id ? TEXT : MUTED }}>
            {label}
          </button>))}
      </div>
      {sub === "deals" && <DealsView />}
      {sub === "network" && <NetworkView />}
      {sub === "counterparties" && <CounterpartiesView />}
    </div>
  );
}
